import { render, staticRenderFns } from "./ContactCoordonnéesRoleEdit.vue?vue&type=template&id=765db35f"
import script from "./ContactCoordonnéesRoleEdit.vue?vue&type=script&lang=ts"
export * from "./ContactCoordonnéesRoleEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports